<template>
  <section>
    <div class="intro-y box mt-6">
      <div
        class="flex flex-col sm:flex-row items-center px-5 py-5 sm:py-3 border-b border-gray-200"
      >
        <h2 class="font-medium text-base mr-auto">
          Editar Tarea - <app-title-custom />
        </h2>
        <div class="form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0">
          Creada por:
          <label class="form-check-label ml-0 sm:ml-2" for="show-example-1">
            {{ task_current.user_created_name }} - {{ task_current.created_at }}
          </label>
        </div>
      </div>
      <form @submit.prevent="updateTask()" class="form-task">
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="col-span-12 sm:col-span-6">
            <label>Nombre:</label>
            <input
              type="text"
              class="input w-full border mt-2 flex-1"
              v-model="task_current.name"
              required
              :disabled="![1].includes(usersession.role)"
            />
          </div>
          <div class="col-span-12 sm:col-span-3">
            <label>Fecha de entrega:</label>
            <input
              type="date"
              class="input w-full border mt-2 flex-1"
              v-model="task_current.date"
              required
              :disabled="usersession.role == 4 || task_current.state_id == 4"
            />
          </div>
          <div v-if="usersession.role == 4" class="col-span-12 sm:col-span-3">
            <label>Horas:</label>
            <input
              type="number"
              class="input w-full border mt-2 flex-1"
              v-model="task_current.hours"
              required
              disabled
            />
          </div>
          <div v-else class="col-span-12 sm:col-span-3">
            <label>Horas:</label>
            <input
              type="number"
              class="input w-full border mt-2 flex-1"
              min="0"
              max="100"
              step=".01"
              v-model="task_current.hours"
              required
              :class="task_current.state_id == 4 ? 'cursor-not-allowed' : ''"
              :disabled="task_current.state_id == 4"
            />
          </div>
          <div class="col-span-12 sm:col-span-12 xxl:col-span-12">
            <label>Descripcion</label>
            <textarea
              class="input w-full border mt-2"
              rows="5"
              v-model="task_current.description"
              :disabled="![1].includes(usersession.role)"
            ></textarea>
          </div>
          <div
            class="col-span-12 sm:col-span-3"
            v-if="task_current.campaign_attribute"
          >
            <label>Proyecto</label>
            <input
              type="text"
              class="input w-full border mt-2 flex-1"
              v-model="task_current.campaign_attribute.project_name"
              required
              disabled
            />
          </div>
          <div
            class="col-span-12 sm:col-span-3"
            v-if="task_current.campaign_attribute"
          >
            <label>Campaña</label>
            <input
              type="text"
              class="input w-full border mt-2 flex-1"
              v-model="task_current.campaign_attribute.name"
              required
              disabled
            />
          </div>
          <div v-if="usersession.role == 4" class="col-span-12 sm:col-span-3">
            <label>Estado</label>
            <select
              class="input w-full border mt-2"
              :class="task_current.state_id == 4 ? 'bg-disabled' : ''"
              :disabled="task_current.state_id == 4"
              v-model="task_current.state_id"
              required
            >
              <option disabled>Seleccione el estado...</option>
              <option v-for="state in filteredStates" :value="state.id">
                {{ state.name }}
              </option>
            </select>
          </div>
          <div v-else class="col-span-12 sm:col-span-3">
            <label>Estado</label>
            <select
              class="input w-full border mt-2"
              :class="task_current.state_id == 4 ? 'bg-disabled' : ''"
              :disabled="task_current.state_id == 4"
              v-model="task_current.state_id"
              required
            >
              <option disabled>Seleccione el estado...</option>
              <option
                v-for="state in states"
                :value="state.id"
                :disabled="
                  ![4].includes(state.id) &&
                  usersession.team_id != task_current.team_id
                "
              >
                {{ state.name }}
              </option>
            </select>
          </div>
          <div
            class="col-span-12 sm:col-span-3"
            v-if="usersession.team_id == this.team_session"
          >
            <label>Usuario</label>
            <select
              class="input w-full border mt-2 flex-1"
              :class="task_current.state_id == 4 ? 'bg-disabled' : ''"
              :disabled="task_current.state_id == 4"
              v-model="task_current.user_id"
              required
            >
              <option disabled>Seleccione el usuario</option>
              <template v-for="user in filteredUsers">
                <option
                  v-if="[2, 3, 4, 5].includes(user.roles[0].id)"
                  :key="user.id"
                  :value="user.id"
                >
                  {{ user.name }}
                </option>
              </template>
            </select>
          </div>
          <template v-if="task_current.path">
            <div
              class="relative col-span-12 sm:col-span-4"
              v-for="(path, key) in task_current.path.split(',')"
            >
              <label>Url {{ key + 1 }}</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                :value="path"
                disabled
              />
              <div
                class="absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
                v-if="path"
              >
                <a :href="path" target="_blank">
                  <app-icon name="link" classname="w-4 h-4" />
                </a>
              </div>
            </div>
          </template>

          <!-- ANSWER -->
          <div
            class="col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12 bg-gray-300 px-3 rounded"
            v-if="[3, 4, 5, 6, 7].includes(task_current.state_id)"
          >
            <div class="col-span-12 sm:col-span-12">
              <label>Descripcion Respuesta</label>
              <textarea
                class="input w-full border mt-2"
                rows="3"
                v-model="task_current.response_observations"
                required
                :disabled="
                  task_current.state_id == 6 ||
                  task_current.state_id == 4 ||
                  usersession.team_id != task_current.team_id
                "
              >
              </textarea>
            </div>

            <template v-if="!edit_response_path">
              <p class="relative col-span-12 sm:col-span-12">
                Urls Respuesta
                <a
                  v-on:click="editResponsePath()"
                  v-if="task_current.state_id != 4"
                  >- Editar</a
                >
              </p>
              <div
                class="relative col-span-12 sm:col-span-12"
                v-for="(path, key) in task_current.response_path"
              >
                <label>Url Respuesta {{ key + 1 }}</label>
                <input
                  type="text"
                  class="input w-full border mt-2 flex-1"
                  :value="path"
                />
                <div
                  class="absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
                  v-if="path"
                >
                  <a :href="path" target="_blank">
                    <app-icon name="link" classname="w-4 h-4" />
                  </a>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="relative col-span-6 sm:col-span-6">
                <label>Url Archivo Respuesta (opcional)</label>
                <MultiSelect
                  v-model="response_path"
                  :options="responsePathOptions"
                  :multiple="true"
                  :taggable="true"
                  @tag="addResponseTag"
                  class="mt-2"
                  :disabled="
                    task_current.state_id == 6 ||
                    task_current.state_id == 4 ||
                    usersession.team_id != task_current.team_id
                  "
                />
              </div>
            </template>
          </div>
          <!-- END ANSWER -->
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
          <button
            type="button"
            @click="$emit('closeEditTask')"
            class="button border text-gray-700 mr-1"
          >
            Cancelar
          </button>
          <button
            type="submit"
            class="button bg-theme-1 text-white"
            id="create"
            :disabled="buttonIsLoading"
          >
            <template v-if="buttonIsLoading"> Cargando... </template>
            <template v-else> Modificar </template>
          </button>
        </div>
      </form>

      <h4 class="ml-6 font-bold text-sm pb-2">Listado de Versiones</h4>
      <hr class="mx-5" />
      <TaskEditVersions
        :users="users"
        :states="states"
        :usersession="usersession"
        :task_current="task_current"
        :team_session="team_session"
      />

      <div
        class="border-b border-gray-200 flex flex-col items-center p-5 sm:flex-row"
        v-if="!createVersionVariable"
      >
        <button
          type="button"
          @click="createVersionVariable = true"
          class="button bg-theme-1 text-white"
        >
          Crear Nueva Version
        </button>
      </div>

      <form
        class="intro-y grid grid-cols-12 gap-3 p-5 form-task"
        @submit.prevent="createVersion()"
        v-else
      >
        <div class="col-span-6 sm:col-span-6">
          <label>Descripcion</label>
          <textarea
            class="input w-full border mt-2"
            rows="5"
            v-model="version.observations"
            required
          ></textarea>
        </div>
        <div class="col-span-6 sm:col-span-6">
          <div class="mb-2">
            <label>Fecha</label>
            <input
              type="date"
              class="input w-full border mt-2"
              v-model="version.date"
              required
            />
          </div>
          <label>Url Archivo (opcional)</label>
          <MultiSelect
            v-model="version.path"
            :options="options"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            class="mt-2"
          />
        </div>
        <div class="mt-8 col-span-3 sm:col-span-3">
          <button
            type="submit"
            id="createversion"
            class="button bg-theme-1 text-white"
            :disabled="buttonIsLoading"
          >
            <template v-if="buttonIsLoading"> Cargando... </template>
            <template v-else> Confirmar Nueva Version </template>
          </button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { SHOW_TASKVERSION } from '@/vuex/entity/mutation-types'

import Icon from '@/components/admin/partials/Icon'
import TitleCustom from '@/components/admin/partials/TitleCustom'
import MultiSelect from '@/components/assets/MultiSelect/MultiSelect'
import TaskEditVersions from '@/components/admin/task/TaskEditVersions'

export default {
  props: [
    'users',
    'states',
    'usersession',
    'task_current',
    'team_session',
    'defineQuery',
  ],
  data() {
    return {
      version: this.defineVersion(),
      version_current: this.defineResponseVersion(),
      createVersionVariable: false,
      options: [],
      responsePathOptions: [],
      responseVersionPathOptions: [],
      buttonIsLoading: false,
      edit_response_path: false,
      response_path: [],
    }
  },
  mounted() {
    this.edit_response_path =
      this.task_current.response_path == null ? true : false
  },
  beforeDestroy() {
    this.$store.commit(SHOW_TASKVERSION, [])
  },
  methods: {
    updateTask() {
      let vm = this
      vm.task_current.entity = 'task'
      vm.task_current.response_path = this.edit_response_path
        ? vm.response_path
        : vm.task_current.response_path
      this.buttonIsLoading = true
      const query = this.defineQuery()
      vm.update([vm.task_current, query])
        .then((item) => {
          this.$emit('taskEdited')
        })
        .catch((message) => {
          console.log(message)
        })
        .finally(() => {
          this.buttonIsLoading = false
        })
    },
    defineVersion() {
      return {
        entity: 'taskversion',
        path: [],
      }
    },
    defineResponseVersion() {
      return {
        entity: 'taskversion',
        response_path: [],
        response_observations: '',
      }
    },
    createVersion() {
      var vm = this
      vm.version.task_id = this.task_current.id
      this.buttonIsLoading = true
      console.log(vm.version)
      vm.store(vm.version)
        .then((item) => {
          vm.boxedit = false
          vm.version = this.defineVersion()
          window.location.reload()
        })
        .catch((message) => {
          console.log(message)
        })
        .finally(() => {
          this.buttonIsLoading = false
        })
    },
    updateVersion(item) {
      var vm = this
      this.buttonIsLoading = true
      window.$('#editversion').button('loading')
      vm.version_current.id = item.id
      vm.store(vm.version_current)
        .then((item) => {
          vm.version = this.defineVersion()
          window.location.reload()
        })
        .catch((message) => {
          window.$('#editversion').button('reset')
          this.buttonIsLoading = false
        })
    },
    addTag(newTag) {
      this.options.push(newTag)
      this.version.path.push(newTag)
    },
    editResponsePath() {
      this.edit_response_path = true
    },
    addResponseTag(newTag) {
      this.responsePathOptions.push(newTag)
      if (this.response_path == null) {
        this.response_path = []
      }
      this.response_path.push(newTag)
    },
    addResponseVersionTag(newTag) {
      this.responseVersionPathOptions.push(newTag)
      if (this.version_current.response_path == null) {
        this.version_current.response_path = []
      }
      this.version_current.response_path.push(newTag)
    },
    ...mapActions(['get', 'store', 'update']),
  },
  computed: {
    ...mapGetters({
      //versions: 'getTaskVersion',
    }),
    filteredUsers() {
      return this.users.filter((item) => {
        var accounts_ids = item.accountsIds
        var search = accounts_ids.indexOf(
          this.task_current.campaign_attribute.project_account_id
        )

        if (this.usersession.role == 4) {
          return search !== -1
        } else {
          return search !== -1 && item.team_id == localStorage.session_team
        }
      })
    },
    filteredStates() {
      return this.states.filter((v) => {
        if (this.usersession.team_id != this.task_current.team_id) {
          return v.id == 4
        } else {
          return v.id != 4
        }
      })
    },
  },
  components: {
    appIcon: Icon,
    appTitleCustom: TitleCustom,
    MultiSelect,
    TaskEditVersions,
  },
}
</script>



// WEBPACK FOOTER //
// TaskEditModal.vue?2d88e200